import R from 'app/assets/R'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { BaseInput } from 'app/components/common/inputs/BaseInput'
import { IFilterTradeUnionList } from 'app/containers/TradeUnionMemberManagement/type'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface IProps {
  onChangeFilter?: (filter: IFilterTradeUnionList) => void
  filter?: IFilterTradeUnionList
}

export const FilterLayout: React.FC<IProps> = ({ filter, onChangeFilter }) => {
  const { t } = useTranslation()

  const onChangeSearch = (value: string) => {
    onChangeFilter?.({ ...filter, search: value })
  }

  return (
    <BaseForm>
      <BaseRow gutter={[16, 8]}>
        <BaseCol xl={8}>
          <BaseForm.Item hiddenLabel>
            <BaseInput
              placeholder={t(R.strings.search)}
              value={filter?.search}
              onChange={e => onChangeSearch?.(e?.target?.value)}
              allowClear
            />
          </BaseForm.Item>
        </BaseCol>
      </BaseRow>
    </BaseForm>
  )
}
